module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.appliancesList) ? _c('ul', _vm._l((_vm.appliancesList), function(appliance) {
    return _c('li', {
      key: appliance.iconFile,
      on: {
        "click": function($event) {
          return _vm.selectItem(appliance)
        }
      }
    }, [_c('img', {
      attrs: {
        "width": "70px",
        "src": _vm._f("s3Image")(("appliances/" + (appliance.iconFile))),
        "alt": ""
      }
    }), _vm._v("\n      " + _vm._s(appliance.name) + "\n    ")])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-397b0fc0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/ApplianceList.vue
// module id = 1525
// module chunks = 4